var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-2 text-gray-500 text-xs text-center",attrs:{"id":_vm.$options.name}})}
var staticRenderFns = []

export { render, staticRenderFns }